<div [formGroup]="followupForm">
    @if (model.showMedPhysicsEvaluation && model.medPhysicsEvaluation) {
        <div class="row mb-3 align-items-center">
            <label
                class="col-lg-2 col-form-label text-lg-end text-start"
                [translate]="'CONFIRMATION_FOLLOWUP_MED_PHYSICS_EVALUATION_LABEL'"
                for="radioMedPhysicsEvaluation"
            ></label>
            <div class="col-lg-8">
                <pace-core-radio-input
                    [(model)]="model.medPhysicsEvaluation"
                    [parentForm]="followupFormChildren"
                    id="radioMedPhysicsEvaluation"
                >
                </pace-core-radio-input>
            </div>
        </div>
    }
    <div class="row mb-3 align-items-center">
        <label
            class="col-lg-2 col-form-label text-lg-end text-start"
            [translate]="'CONFIRMATION_FOLLOWUP_QUESTION_LABEL'"
            for="followupOptions"
        ></label>
        <div class="col-lg-8">
            <pace-core-radio-input
                [(model)]="model.followupOptions"
                [parentForm]="followupFormChildren"
                id="radioFollowupOptions"
                (valueChange)="showHideControls()"
            >
            </pace-core-radio-input>
        </div>
    </div>
    @if (showFollowUpAppointment) {
        @if (model.isAppBookingEnabled) {
            <div class="row mb-3 align-items-center">
                <label
                    class="col-lg-2 col-form-label text-lg-end text-start"
                    [translate]="'CONFIRMATION_FOLLOWUP_TYPE_LABEL'"
                    for="radioFollowupType"
                ></label>
                <div class="col-lg-8">
                    <pace-core-radio-input
                        [(model)]="model.appBookingOptions"
                        [parentForm]="followupFormChildren"
                        id="radioFollowupType"
                        (valueChange)="determineFollowupType()"
                    >
                    </pace-core-radio-input>
                </div>
            </div>
        }
        @if (model.appBookingOptions?.getSelectedValue() === optionValueYes) {
            <div class="row mb-3 align-items-center">
                <div class="offset-lg-2">
                    <button
                        class="btn nav-item"
                        [ngClass]="model.isAppointmentConfirmed ? 'btn-primary' : 'btn-danger'"
                        [disabled]="model.isAppointmentConfirmed"
                        type="button"
                        [translate]="'CONFIRMATION_FOLLOWUP_SEARCH_FOR_APPOINTMENTS_LABEL'"
                        (click)="openAppointmentModal()"
                    ></button>
                </div>
            </div>
            <div class="row mb-3 align-items-center">
                <label
                    class="col-lg-2 col-form-label text-lg-end text-start"
                    [translate]="'CONFIRMATION_FOLLOWUP_APPOINTMENT_START_LABEL'"
                    for="appointmentStartDate"
                ></label>
                <div class="col-lg-2">
                    <pace-core-date-input
                        [(model)]="model.appointmentDate"
                        [parentForm]="followupFormChildren"
                        id="appointmentStartDate"
                    >
                    </pace-core-date-input>
                </div>
            </div>
            <div class="row mb-2 align-items-center">
                <label
                    class="col-lg-2 col-form-label text-lg-end text-start"
                    [translate]="'CONFIRMATION_FOLLOWUP_APPOINTMENT_TIME_LABEL'"
                    for="appointmentEndDate"
                ></label>
                <div class="col-lg-2">
                    <pace-core-time-input
                        [(model)]="model.appointmentTime"
                        [parentForm]="followupFormChildren"
                        id="appointmentEndDate"
                    >
                    </pace-core-time-input>
                </div>
            </div>
            <div class="row mb-2 align-items-center">
                <label
                    class="col-lg-2 col-form-label text-lg-end text-start"
                    [translate]="'CONFIRMATION_FOLLOWUP_APPOINTMENT_DURATION_LABEL'"
                    for="appointmentDuration"
                ></label>
                <label class="col-lg-2 text-start" for="appointmentDuration">
                    {{
                        'CONFIRMATION_FOLLOWUP_APPOINTMENT_DURATION_HOURS_LABEL'
                            | translate: { duration: model.appBookingDuration }
                    }}</label
                >
            </div>
            @if (model.isDedicatedResourceEnabled) {
                <div class="row mb-2 align-items-center">
                    <label
                        class="col-lg-2 col-form-label text-lg-end text-start"
                        [translate]="'CONFIRMATION_FOLLOWUP_APPOINTMENT_DEDICATED_RESOURCE_LABEL'"
                        for="appointmentDedicatedResource"
                    ></label>
                    <label
                        class="col-lg-2 text-start"
                        [translate]="
                            model.defaultDedicatedResource
                                ? 'CONFIRMATION_FOLLOWUP_APPOINTMENT_DEDICATED_RESOURCE_REQUIRED_LABEL'
                                : 'CONFIRMATION_FOLLOWUP_APPOINTMENT_DEDICATED_RESOURCE_NOT_REQUIRED_LABEL'
                        "
                        for="appointmentDedicatedResource"
                    >
                    </label>
                </div>
            }
        } @else if (model.appBookingOptions?.getSelectedValue() === optionValueNo || !model.isAppBookingEnabled) {
            @if (showStartImmediately || showRemoteWork) {
                <div class="row mb-3">
                    <div class="offset-lg-2 d-flex gap-3">
                        @if (showStartImmediately) {
                            <pace-core-checkbox-input
                                checkBoxID="startImmediately"
                                [(model)]="model.startImmediately"
                                [parentForm]="followupFormChildren"
                                (valueChange)="model.onChangeStartImmediately()"
                            ></pace-core-checkbox-input>
                        }
                        @if (showRemoteWork) {
                            <pace-core-checkbox-input
                                checkBoxID="remoteWork"
                                [(model)]="model.remoteWork"
                                [parentForm]="followupFormChildren"
                                (valueChange)="model.remoteWorkValue = model.remoteWork.model.value"
                            ></pace-core-checkbox-input>
                        }
                    </div>
                </div>
            }
            <div class="row mb-3">
                <label
                    class="col-lg-2 col-form-label text-lg-end text-start"
                    [translate]="'CONFIRMATION_FOLLOWUP_APPOINTMENT_LABEL'"
                    for="appointmentTime"
                ></label>
                <div class="col-lg-8">
                    <pace-core-datetime-input
                        [(model)]="model.appointmentTime"
                        [parentForm]="followupFormChildren"
                        [ariaLabel]="'CONFIRMATION_FOLLOWUP_APPOINTMENT_LABEL' | translate"
                        (valueChange)="model.appointmentDate.value = model.appointmentTime.value"
                    ></pace-core-datetime-input>
                </div>
            </div>
            <div class="row mb-3 align-items-center">
                <label
                    class="col-lg-2 col-form-label text-lg-end text-start"
                    [translate]="'CONFIRMATION_FOLLOWUP_ADDITIONAL_TIME_LABEL'"
                    for="additionalTime"
                ></label>
                <div class="col-lg-8">
                    <pace-core-duration-stepper
                        id="durationStepper"
                        [(model)]="model.additionalTime"
                        [parentForm]="followupFormChildren"
                        [ariaLabel]="'CONFIRMATION_FOLLOWUP_ADDITIONAL_TIME_LABEL' | translate"
                    >
                    </pace-core-duration-stepper>
                </div>
            </div>
            @if (model.followUpReasons && model.followUpReasons.value.length) {
                <div class="row mb-3 align-items-center">
                    <label
                        class="col-lg-2 col-form-label text-lg-end text-start"
                        [translate]="'CONFIRMATION_FOLLOWUP_REASON_LABEL'"
                        for="followUpReasons"
                    ></label>
                    <div class="col-lg-8">
                        <pace-core-dropdown
                            [(model)]="model.followUpReasons"
                            [parentForm]="followupFormChildren"
                            id="dropdownFollowupReasons"
                        ></pace-core-dropdown>
                    </div>
                </div>
            }
        }
    }

    @if (showUMRCodeDropdown) {
        <div class="row mb-3 align-items-center">
            <label
                class="col-lg-2 col-form-label text-lg-end text-start"
                [translate]="'CONFIRMATION_FOLLOWUP_CODE_GROUP_LABEL'"
                for="followUpUMRCodes"
            ></label>
            <div class="col-lg-8">
                <pace-core-dropdown
                    [(model)]="model.followUpUMRCodes"
                    [parentForm]="followupFormChildren"
                    id="dropdownComplaintsCodeGroup"
                ></pace-core-dropdown>
            </div>
        </div>
    }

    @if (showFollowUpAppointment) {
        @if (model.isForced && model.followupTextLong && model.followupTextLong.value) {
            <div class="row mb-3 align-items-center">
                <label
                    class="col-lg-2 col-form-label text-lg-end text-start"
                    [translate]="'CONFIRMATION_FOLLOWUP_TEXT_LABEL'"
                    for="followupTextLong"
                ></label>
                <div class="col-lg-8">
                    <pace-core-text-input
                        [(model)]="model.followupTextLong"
                        [parentForm]="followupFormChildren"
                        [ariaLabel]="'CONFIRMATION_FOLLOWUP_TEXT_LABEL' | translate"
                    ></pace-core-text-input>
                </div>
            </div>
        }

        @if (model.additionalInfo) {
            <div class="row mb-3 align-items-center">
                <label
                    class="col-lg-2 col-form-label text-lg-end text-start"
                    [translate]="'CONFIRMATION_FOLLOWUP_ADDITIONAL_INFORMATION_LABEL'"
                    for="additionalInfo"
                ></label>
                <div class="col-lg-8">
                    <pace-core-text-input
                        [(model)]="model.additionalInfo"
                        [parentForm]="followupFormChildren"
                        [ariaLabel]="'CONFIRMATION_FOLLOWUP_ADDITIONAL_INFORMATION_LABEL' | translate"
                    ></pace-core-text-input>
                </div>
            </div>
        }
    }

    <!-- should be displayed only if No follow up required-->

    @if (isFollowUpSelectedNo) {
        @if (model.reasonsCode || model.reasonsCodeFallback) {
            <div class="row mb-3">
                <label
                    class="col-lg-2 col-form-label text-lg-end text-start"
                    [translate]="'CONFIRMATION_EQUIPMENT_REASON_LABEL'"
                    for="reasonsCode"
                ></label>
                @if (model.reasonsCode) {
                    <div class="col-lg-6">
                        <pace-core-tree-view
                            [(model)]="model.reasonsCode"
                            [parentForm]="followupFormChildren"
                            (valueChange)="triggerValidationOnReasonsCodeChange()"
                        ></pace-core-tree-view>
                    </div>
                }
                @if (model.reasonsCodeFallback) {
                    <div class="col-lg-4">
                        <pace-core-dropdown
                            [(model)]="model.reasonsCodeFallback"
                            [parentForm]="followupFormChildren"
                        ></pace-core-dropdown>
                    </div>
                }
            </div>
        }
        @if (
            model.reasonsCode &&
            model.reasonsCode.selectedEntry &&
            model.reasonsCode.selectedEntry.payload.codeGroup.value.indexOf(model.assayIndicator) === 0
        ) {
            <div class="row mb-3 align-items-center">
                <label
                    class="col-lg-2 col-form-label text-lg-end text-start"
                    [translate]="'CONFIRMATION_EQUIPMENT_ASSAY_NUMBER_LABEL'"
                    for="assayNumber"
                ></label>
                <div class="col-lg-8">
                    <pace-core-text-input
                        [(model)]="model.assayNumber"
                        [parentForm]="followupFormChildren"
                        [ariaLabel]="'CONFIRMATION_EQUIPMENT_ASSAY_NUMBER_LABEL' | translate"
                    ></pace-core-text-input>
                </div>
            </div>
            <div class="row mb-3 align-items-center">
                <label
                    class="col-lg-2 col-form-label text-lg-end text-start"
                    [translate]="'CONFIRMATION_EQUIPMENT_LOT_NUMBER_LABEL'"
                    for="lotNumber"
                ></label>
                <div class="col-lg-8">
                    <pace-core-text-input
                        [(model)]="model.lotNumber"
                        [parentForm]="followupFormChildren"
                        [ariaLabel]="'CONFIRMATION_EQUIPMENT_LOT_NUMBER_LABEL' | translate"
                    ></pace-core-text-input>
                </div>
            </div>
        }
    }

    <!-- Legal check questions for Turkey -->
    @if (isFollowUpSelectedNo && model.showLegalCheckHandover) {
        <div class="row mb-3 align-items-center">
            <label class="col-lg-2 col-form-label text-lg-end text-start" for="legalCheckHandoverSafetyInformationText">
                {{ model.legalCheckHandoverSafetyInformationText }}
            </label>
            <div class="col-lg-8">
                <pace-core-radio-input
                    [(model)]="model.legalCheckHandoverSafetyInformation"
                    [parentForm]="parentForm"
                ></pace-core-radio-input>
            </div>
        </div>
        <div class="row mb-3 align-items-center">
            <label class="col-lg-2 col-form-label text-lg-end text-start" for="legalCheckHandoverUserDocumentationText">
                {{ model.legalCheckHandoverUserDocumentationText }}
            </label>
            <div class="col-lg-8">
                <pace-core-radio-input
                    [(model)]="model.legalCheckHandoverUserDocumentation"
                    [parentForm]="parentForm"
                ></pace-core-radio-input>
            </div>
        </div>
    }
</div>
